import * as Yup from 'yup';
import { TType } from '@translations/translationsTypes';

export const visitRequestFormValidationScheme = (t: TType, isVip: boolean) => {
  return Yup.object()
    .shape({
      identity: !isVip ? Yup.string().required(t('global.error.required')) : Yup.string(),
      identityValue: !isVip
        ? Yup.string().when('identity', {
            is: (identity: string) => identity === 'NATIONAL_ID' || identity === 'IQAMA',
            then: (scheme) =>
              scheme
                .required(t('global.error.required'))
                .length(10, t('global.error.documentId.10Ch')),
            otherwise: (scheme) =>
              scheme
                .required(t('global.error.required'))
                .max(25, t('global.error.documentId.25Ch'))
                .min(10, t('global.error.documentId.10ChMin')),
          })
        : Yup.string(),
    })
    .nullable();
};
